/** Web Storage 布尔标记：0 否 / 1 是 */
export const STORAGE_FLAG_OFF = 0;
export const STORAGE_FLAG_ON = 1;

export type TStorageFlag = typeof STORAGE_FLAG_OFF | typeof STORAGE_FLAG_ON;

type TStorageKind = 'local' | 'session';

function getBrowserStorage(kind: TStorageKind): Storage | null {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return kind === 'local' ? window.localStorage : window.sessionStorage;
    } catch {
        return null;
    }
}

function createBrowserStore(kind: TStorageKind) {
    const getStorage = () => getBrowserStorage(kind);

    return {
        isAvailable(): boolean {
            return getStorage() !== null;
        },

        getItem(key: string): string | null {
            const storage = getStorage();
            if (!storage) {
                return null;
            }
            try {
                return storage.getItem(key);
            } catch {
                return null;
            }
        },

        setItem(key: string, value: string): void {
            const storage = getStorage();
            if (!storage) {
                return;
            }
            try {
                storage.setItem(key, value);
            } catch {
                // 隐私模式、配额满等
            }
        },

        removeItem(key: string): void {
            const storage = getStorage();
            if (!storage) {
                return;
            }
            try {
                storage.removeItem(key);
            } catch {
                // 隐私模式等
            }
        },

        getNumberFlag(key: string): TStorageFlag {
            const raw = this.getItem(key);
            if (raw === null || raw === '') {
                return STORAGE_FLAG_OFF;
            }
            const value = Number(raw);
            return value === STORAGE_FLAG_ON ? STORAGE_FLAG_ON : STORAGE_FLAG_OFF;
        },

        setNumberFlag(key: string, value: TStorageFlag): void {
            this.setItem(key, String(value));
        },
    };
}

/** localStorage 封装，SSR / 无 window 时安全降级 */
export const localStore = createBrowserStore('local');

/** sessionStorage 封装，SSR / 无 window 时安全降级 */
export const sessionStore = createBrowserStore('session');
